import { FC } from 'react';
import styles from './divider.module.scss';

type DividerProps = React.ComponentPropsWithoutRef<'div'>;

export const Divider: FC<DividerProps> = ({ style }) => {
    return <div className={styles.line} style={style} />;
};
